import FormModule from "components/Modules/Documents/FormModule"
import {
  createOrUpdateFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import {
  normalizeWidgetData,
  prepareWidgetDataForSave,
} from "../budgetWidgetData"

const CityBudgetExpenses = () => {
  return (
    <FormModule
      noCancel
      form={{
        title: "Expenses",
        fields: [
          {
            ID: "budget-expenses-table",
            Type: "Editable Table",
            Name: "WidgetData.data.2.data",
            Label: "Expenses",
            Columns: [
              { Name: "color", Label: "Color", Editable: true },
              { Name: "name", Label: "Name", Editable: true },
              {
                Name: "value",
                Label: "Value",
                Editable: true,
              },
            ],
            DeletedName: "DeletedExpenses",
            Creatable: true,
            Orderable: true,
          },
        ],
        getDefaultValues: async ({ firebaseUID }) => {
          const moduleDoc = await getFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/136`,
          })

          return {
            WidgetData: normalizeWidgetData(moduleDoc?.WidgetData || {}),
            DeletedExpenses: [],
          }
        },
        onSubmit: async (values, { firebaseUID }) => {
          const widgetData = prepareWidgetDataForSave(values.WidgetData || {})

          await createOrUpdateFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules`,
            values: {
              ID: "136",
              WidgetData: widgetData,
            },
          })

          return values
        },
      }}
      ID={"136"}
    />
  )
}

export default CityBudgetExpenses
